<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $tc('models.carrier', 2) }}
          <v-btn color="primary" @click="goTo('newCarrier')"> {{ $t('create') }} </v-btn>
          <v-btn color="primary" v-if="$auth.isDev()" @click="goTo('importCarrier')">
            {{ $t('UploadCarrier') }}
          </v-btn>
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-tabs slider-color="primary" v-model="activeTab" centered class="elevation-1" @change="slideChange">
          <v-tab>
            {{ $t('all') }}
          </v-tab>

          <v-tab ripple>
            {{ $t('list.statuses.active') }}
          </v-tab>

          <v-tab ripple>
            {{ $t('list.statuses.suspended') }}
          </v-tab>

          <v-tab-item>
            <carrier-index :status="'all'" ref="carrier-index-0"></carrier-index>
          </v-tab-item>

          <v-tab-item>
            <carrier-index :status="'active'" ref="carrier-index-1"></carrier-index>
          </v-tab-item>

          <v-tab-item>
            <carrier-index :status="'suspended'" ref="carrier-index-2"></carrier-index>
          </v-tab-item>
        </v-tabs>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Carrier from '@/client/carrier'
import carrierIndex from '@/components/carriers/index'

export default {
  props: {},

  data () {
    return {
      statuses: ['all', 'active', 'suspended'],
      activeTab: ''
    }
  },

  components: {
    carrierIndex
  },

  computed: {
  },

  methods: {
    slideChange(e) {
      this.$store.state.carrierIndexTab = this.activeTab = e
    },

    process() {
      this.$refs[`carrier-index-${ this.activeTab }`].fetch()
    }
  },

  watch: {
    activeTab () {
      this.process()
    }
  },

  async mounted () {
    this.activeTab = this.$store.state.carrierIndexTab
  }
}
</script>
